import request from '@/utils/request'

export async function login(data) {
  return await request({
    url: 'login',
    method: 'post',
    data
  })
}

//订单列表
export async function OrderList(data) {
  return await request({
    url: 'exchange-server/Exchange/OrderList',
    method: 'post',
    data
  })
}

//商品列表
export async function CommodityList(data) {
  return await request({
    url: 'exchange-server/Exchange/CommodityList',
    method: 'post',
    data
  })
}

//卡密列表
export async function CardPasswordList(data) {
  return await request({
    url: 'exchange-server/Exchange/CardPasswordList',
    method: 'post',
    data
  })
}

//价格列表
export async function PriceTypeList(data) {
  return await request({
    url: 'exchange-server/Exchange/PriceTypeList',
    method: 'post',
    data
  })
}

//新增卡密
export async function InsertCardPassword(data) {
  return await request({
    url: 'exchange-server/Exchange/InsertCardPassword',
    method: 'post',
    data
  })
}

//编辑卡密
export async function UpdateCardPassword(data) {
  return await request({
    url: 'exchange-server/Exchange/UpdateCardPassword',
    method: 'post',
    data
  })
}

//删除卡密
export async function DeleteCardPassword(data) {
  return await request({
    url: 'exchange-server/Exchange/DeleteCardPassword',
    method: 'post',
    data
  })
}

//新增/修改商品信息 
export async function UpdateCommodityInfo(data) {
  return await request({
    url: 'exchange-server/Exchange/UpdateCommodityInfo',
    method: 'post',
    data
  })
}

//删除商品信息 
export async function DeleteCommodityInfo(data) {
  return await request({
    url: 'exchange-server/Exchange/DeleteCommodityInfo',
    method: 'post',
    data
  })
}

//填写物流
export async function UpdateOddNumbers(data) {
  return await request({
    url: 'exchange-server/Exchange/UpdateOddNumbers',
    method: 'post',
    data
  })
}

//删除订单
export async function DeleteOrderInfo(data) {
  return await request({
    url: 'exchange-server/Exchange/DeleteOrderInfo',
    method: 'post',
    data
  })
}

//物流信息
export async function QueryRoute(data) {
  return await request({
    url: 'exchange-server/Exchange/QueryRoute',
    method: 'post',
    data
  })
}


export async function getWechatQrCode(data) {
  return await request({
    url: 'getWechatQrCode',
    method: 'post',
    data
  })
}


//新增编辑分类
export async function InsertCardType(data) {
  return await request({
    url: 'exchange-server/Exchange/InsertCardType',
    method: 'post',
    data
  })
}

//批量修改卡密激活状态
export async function UpdateCardActivation(data) {
  return await request({
    url: 'exchange-server/Exchange/UpdateCardActivation',
    method: 'post',
    data
  })
}

// 售后状态
export async function UpdateServiceStatus(data) {
  return await request({
    url: 'exchange-server/Exchange/UpdateServiceStatus',
    method: 'post',
    data
  })
}

//批量导入物流信息
export async function BatchUpdateOddNumbers(data) {
  return await request({
    url: 'exchange-server/Exchange/BatchUpdateOddNumbers',
    method: 'post',
    data
  })
}

//统计
export async function Statistics(data) {
  return await request({
    url: 'exchange-server/Exchange/Statistics',
    method: 'post',
    data
  })
}

//删除卡号类型
export async function DeleteCardType(data) {
  return await request({
    url: 'exchange-server/Exchange/DeleteCardType',
    method: 'post',
    data
  })
}

//账户列表
export async function queryUserList(data) {
  return await request({
    url: 'exchange-server/User/queryUserList',
    method: 'post',
    data
  })
}

//创建用户
export async function createUser(data) {
  return await request({
    url: 'exchange-server/User/createUser',
    method: 'post',
    data
  })
}

//查用户信息
export async function findUserById(data) {
  return await request({
    url: 'exchange-server/User/findUserById',
    method: 'post',
    data
  })
}

//更新用户
export async function updateUser(data) {
  return await request({
    url: 'exchange-server/User/updateUser',
    method: 'post',
    data
  })
}

//禁用/启用用户
export async function updateEnableState(data) {
  return await request({
    url: 'exchange-server/User/updateEnableState',
    method: 'post',
    data
  })
}

//修改密码
export async function updatePassword(data) {
  return await request({
    url: 'exchange-server/User/updatePassword',
    method: 'post',
    data
  })
}

//删除用户
export async function deleteUser(data) {
  return await request({
    url: 'exchange-server/User/deleteUser',
    method: 'post',
    data
  })
}




